import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 537",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0.866 460L265.87 1 530.874 460z"
	})
});
export default SvgTriangleUp;
